<template>
	<template v-if="selectedStage !== 0">
	<Header />
	<div class="home">
		<div class="px-8 pt-8 bg-darkblue bottom-panel">
			<Form v-if="selectedStage === 1"  @next="selectedStage = 2"/>
			<Success v-else-if="selectedStage === 2" />
		</div>
		<Footer />
	</div>
	</template>
	<Landing v-else @next="selectedStage = 1" />
</template>

<script>
import { ref, watch } from 'vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Landing from '@/components/Landing.vue'
import Form from '@/components/Form.vue'
import Success from '@/components/Success.vue'
export default {
	name: 'Home',
	components: {
		Header,
		Footer,
		Landing,
		Form,
		Success,
	},
	setup(ctx, props) {
		/** Stage logic */
		const stages = {
			landing: 0,
			form: 1,
			success: 2,
		}
		const selectedStage = ref(0)

		watch(() => selectedStage.value, (val) => {
			window.scrollTo(0, 0)
		})

		return {
			selectedStage,
			stages,
		}
	},
}
</script>

<style scoped></style>
